import {
  filterMotionRecordsForTimelineRig,
  type TimelineMotionRig,
} from '../shared/timelineMotionSourceCompatibility';
import type { AssetLibraryGroupDetailItem } from './assetLibraryGroupDetail';
import type { GroupDetailPageResult } from './assetLibraryGroupDetailLoader';

export function filterGroupDetailPageForTimelineRig(
  page: GroupDetailPageResult,
  requiredTimelineRig: TimelineMotionRig | null | undefined,
): GroupDetailPageResult {
  if (!requiredTimelineRig || page.projectMotions.length === 0) {
    return page;
  }

  const filteredMotions = filterMotionRecordsForTimelineRig(
    page.projectMotions,
    requiredTimelineRig,
  );
  const allowedIds = new Set(filteredMotions.map((motion) => motion.jobID));

  return {
    ...page,
    projectMotions: filteredMotions,
    items: page.items.filter((item: AssetLibraryGroupDetailItem) =>
      allowedIds.has(item.id),
    ),
  };
}
